import { SvgIconName } from '~src/shared/SvgIcon';
import { ConfigDataI } from '~src/services/fetch/import.service';

export enum IntegrationStatus {
  Running = 'running',
  Failed = 'failed',
  Successful = 'successful',
  PreviewReady = 'preview',
}

export interface UploadingStatusI {
  error?: string;
  status?: IntegrationStatus;
  progress?: number;
}

export interface IntegrationItemProps {
  title: string;
  description?: string | [string, { [key: string]: string }];
  integrationHelp: string;
  svgIcon?: SvgIconName;
  icon?: string;
  configForm: {
    name: string;
    fields: Array<{ name: string; labelKey: string; tooltipTxt?: string }>;
    defaultValues?: ConfigDataI;
    auto_import: boolean;
  };
}
